import { useNavigate } from "react-router";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER, DISCOVER_SEARCH } from "../../../constants/routes";
import { useDiscoveryProductRecentlyAddedGroup } from "../../../hooks/api/v2/discovery/useDiscoveryProductRecentlyAddedGroup";
import { DiscoverySubPageListsView } from "./components/DiscoverySubPageListsView";
import { useDiscoveryV2SearchStore } from "./DiscoveryV2SearchStore";

export const DiscoveryV2RecentlyAdded = () => {
  const navigate = useNavigate();
  const setOrderBy = useDiscoveryV2SearchStore((state) => state.setOrderBy);
  const discoveryRecentlyAddedQuery = useDiscoveryProductRecentlyAddedGroup({
    limit: 20,
  });

  const redirectDiscover = () => {
    setOrderBy("updatedAt");
    navigate(DISCOVER_SEARCH);
  };

  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={"Latest releases"}
      />
      <DiscoverySubPageListsView
        query={discoveryRecentlyAddedQuery}
        onRedirect={redirectDiscover}
      />
    </>
  );
};
